import { Injectable } from '@angular/core';
import { CanDeactivate, RouterStateSnapshot, CanActivate, ActivatedRouteSnapshot, GuardResult, MaybeAsync, Router } from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate, CanDeactivate<any> {
    constructor(private readonly router: Router) { }

    canDeactivate(
        _component: any,
        _currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot
    ) {
        const currentUrl = currentState?.url;
        if (!currentUrl) {
            return true;
        }
        const isValid = window.localStorage.length > 0;
        if ((currentUrl === '/logout' || currentUrl === '/no-cepm-role'
            || currentUrl === '/supplier-out-of-scope'
            || currentUrl === '/no-role-external') && !isValid) {
            return false;
        }
        else {
            return true;
        }
    }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> {
        const requiredRoles = route?.data && route?.data.roles ? route?.data?.roles : [];
        const respData = JSON.parse(window.localStorage.getItem('cepmRespData'));
        let redirectionFlag: any = false;
        if (respData?.roles?.length > 0) {
            if (state.url?.includes('/fhr-tracker')) {
                let allowedUrls: any[] = [];
                if (respData.roles[0].value === 'scw_admin') {
                    allowedUrls = ['/fhr-tracker/current-mapping', '/fhr-tracker/supplier-view/all-suppliers'];
                }
                else if (respData.roles[0].value === 'supply_chain_view_access' || respData.roles[0].value === 'gsm_general_user_okta') {
                    allowedUrls = ['/fhr-tracker/supplier-view/all-suppliers'];
                }
                else {
                    allowedUrls = ['/fhr-tracker/supplier-view/my-suppliers', '/fhr-tracker/supplier-view/all-suppliers'];
                }

                if (!allowedUrls.includes(state.url) || respData.roles[0].value === 'scw_supplier_user') {
                    if (respData.roles[0].value === 'scw_supplier_user') {
                        this.router.navigate(['/supplier-new-home']);
                    }
                    redirectionFlag = false;
                } 
                else {
                    redirectionFlag = true;
                }
            }
            else {
                if (respData.roles[0].value === 'scw_supplier_user' && !requiredRoles.includes(respData.roles[0].value)) {
                    this.router.navigate(['/supplier-new-home']);
                    redirectionFlag = false;
                } 
                else {
                    redirectionFlag = true;
                }
            }
        }
        else {
            const loginType = window.localStorage.getItem('type');
            if (loginType === 'login') {
                // Login is in progress — cepmRespData not yet available.
                // Save the intended URL so redirectBasedOnRole() can navigate
                // to it once CEPM roles are fetched.
                window.localStorage.setItem('path', state.url);
            } else {
                this.router.navigate(['/no-cepm-role']);
            }
            redirectionFlag = false;
        }
        return redirectionFlag;
    }
}
